// Polyfill for padStart
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intl';
import 'intl/locale-data/jsonp/en'
if (!String.prototype.padStart) {
  String.prototype.padStart = function (targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String((typeof padString !== 'undefined' ? padString : ' '));
    if (this.length > targetLength) {
      return String(this);
    }
    targetLength = targetLength - this.length;
    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length);
    }
    return padString.slice(0, targetLength) + String(this);
  };
}


if (typeof Intl === 'undefined') {
  import('intl')
    .then(() => {
      return import('intl/locale-data/jsonp/en'); // Load the locale data
    })
    .then(() => {
      console.log('Intl polyfill loaded successfully');
    })
    .catch((err) => {
      console.error('Error loading Intl polyfill:', err);
    });
} else {
  console.log('Intl is supported natively');
}


import Vue from 'vue'
import App from './App'
import Notifications from 'vue-notification'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import router from './router'
import Promise from 'es6-promise'
import Vuesax from '../node_modules/vuesax'
import 'vuesax/dist/vuesax.css'


Vue.use(Notifications)
Promise.polyfill();
Vue.config.productionTip = false

Vue.use(Vuesax,{
  //opciones
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js